import { FC, useRef } from 'react';

import { Drop } from '@hh.ru/magritte-ui';

import FavoritesButton from 'src/components/ResumeCard/Actions/SaveToFavoritesButton/Button';
import ResumeFolders from 'src/components/ResumeFolders';

import { SaveToFavoritesProps } from 'src/components/ResumeCard/Actions/SaveToFavoritesButton/Menu/types';

const SaveToFavoritesMenuDesktop: FC<SaveToFavoritesProps> = ({
    isVisible,
    folders,
    foldersIdList,
    isSaved,
    onClick,
    onSave,
    closeAdditionalMenu,
}) => {
    const activatorRef = useRef(null);

    return (
        <>
            <Drop visible={isVisible} placement="top-right" activatorRef={activatorRef} maxWidth={300}>
                <ResumeFolders
                    onSave={onSave}
                    folders={folders}
                    selectedIdsFolder={foldersIdList}
                    dataQAPrefix="resume-serp__favourite-popup"
                    isMagritte
                />
            </Drop>
            <FavoritesButton
                ref={activatorRef}
                isSaved={isSaved}
                onClick={onClick}
                closeAdditionalMenu={closeAdditionalMenu}
            />
        </>
    );
};

export default SaveToFavoritesMenuDesktop;
